export default __webpack_public_path__ + "media/images/close-63239d0b907f73b8153c11eb56098670.svg";